import { Box, Container } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { ShiftHeader } from '@operations/features/shift/components/molecules/ShiftHeader'
import { ShiftTable } from '@operations/features/shift/components/organisms/ShiftTable'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

export const ShiftPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()

    const { shiftStore } = useOperationsStore()

    useAsyncFetch(async () => {
      await shiftStore.fetchData()
    }, [shiftStore])

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <ShiftHeader />

        <Container sx={{ paddingY: theme.customSpacing.m }} data-cy='operational-equipment-table'>
          <ShiftTable shiftStore={shiftStore} />
        </Container>
      </Box>
    )
  }),
)
